import { ExecutionAnswer, ListService } from "@/types";

export const AnswerService: ListService<ExecutionAnswer> = {};
